import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.replace";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export function request(_x, _x2, _x3) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(method, url, data) {
    var extra,
        _extra$headers,
        headers,
        onProgress,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            extra = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            _extra$headers = extra.headers, headers = _extra$headers === void 0 ? {} : _extra$headers, onProgress = extra.onProgress;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open(method, url);
              Object.keys(headers).forEach(function (key) {
                return xhr.setRequestHeader(key, headers[key]);
              });
              xhr.addEventListener('load', function (e) {
                var data = null;

                try {
                  data = JSON.parse(e.target.responseText);
                } catch (err) {
                  data = e.target.responseText;
                }

                return resolve(data);
              });
              xhr.addEventListener('error', function (err) {
                return reject(err);
              });
              xhr.upload.addEventListener('progress', onProgress);

              if (headers['Content-Type'] === 'application/json') {
                xhr.send(JSON.stringify(data));
              } else {
                xhr.send(data);
              }
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _request.apply(this, arguments);
}

export function sanitizeFilename(filename) {
  return filename.replace(/[^a-z0-9.]/gi, '_');
}